// Keeps old `?searchquery=` links (newsletters, ads, bookmarks) working after
// KFT-4023 renamed the search param to `?query=`.
export default defineNuxtRouteMiddleware((to) => {
  const query = renameLegacySearchQueryParam(to.query)
  if (!query) return

  setRedirectLogReason('legacy-url')
  return navigateTo(
    { path: to.path, query, hash: to.hash },
    { redirectCode: 301 }
  )
})
